import { render, staticRenderFns } from "./Color-Multiselect-Dropdown.vue?vue&type=template&id=5c78c783&"
import script from "./Color-Multiselect-Dropdown.vue?vue&type=script&lang=js&"
export * from "./Color-Multiselect-Dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports